/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { WorkspaceInvite } from '../models/WorkspaceInvite';
import type { WorkspaceInviteBulkRequest } from '../models/WorkspaceInviteBulkRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class WorkspaceInviteService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Get Workspace Invites
   * @param slug
   * @returns WorkspaceInvite Successful Response
   * @throws ApiError
   */
  public getWorkspaceInvitesV1WorkspacesSlugInvitesGet(
    slug: string
  ): CancelablePromise<Array<WorkspaceInvite>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/workspaces/{slug}/invites',
      path: {
        slug: slug,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Get Workspace Invite
   * @param inviteId
   * @param slug
   * @returns WorkspaceInvite Successful Response
   * @throws ApiError
   */
  public getWorkspaceInviteV1WorkspacesSlugInvitesInviteIdGet(
    inviteId: number,
    slug: string
  ): CancelablePromise<WorkspaceInvite> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/workspaces/{slug}/invites/{invite_id}',
      path: {
        invite_id: inviteId,
        slug: slug,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Resend Workspace Invite
   * @param inviteId
   * @param slug
   * @returns any Successful Response
   * @throws ApiError
   */
  public resendWorkspaceInviteV1WorkspacesSlugInvitesInviteIdResendPost(
    inviteId: number,
    slug: string
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/v1/workspaces/{slug}/invites/{invite_id}/resend',
      path: {
        invite_id: inviteId,
        slug: slug,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Cancel Workspace Invite
   * @param inviteId
   * @param slug
   * @returns WorkspaceInvite Successful Response
   * @throws ApiError
   */
  public cancelWorkspaceInviteV1WorkspacesSlugInvitesInviteIdCancelPost(
    inviteId: number,
    slug: string
  ): CancelablePromise<WorkspaceInvite> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/v1/workspaces/{slug}/invites/{invite_id}/cancel',
      path: {
        invite_id: inviteId,
        slug: slug,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Create Workspace Invite
   * @param slug
   * @param requestBody
   * @returns WorkspaceInvite Successful Response
   * @throws ApiError
   */
  public createWorkspaceInviteV1WorkspacesSlugInvitesBulkPost(
    slug: string,
    requestBody: WorkspaceInviteBulkRequest
  ): CancelablePromise<Array<WorkspaceInvite>> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/v1/workspaces/{slug}/invites/bulk',
      path: {
        slug: slug,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
